import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Message from "../../components/Message";
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function OtherState() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { returning = false } = location.state || {};

  const handleBack = () => {
    setPageAndDeferNavigate(dispatch, '/demographic', navigate);
  };

  return (
    <Message
      onBack={handleBack}
      returning={returning}
      title={returning ? "Sorry, unfortunately, we do not currently offer care in your state. We will be happy to see you when you move to a state we deliver care in." : "Sorry, we are not currently available in your state. We will text you as soon as we are."}
      subtitle="Please call 911 in case of an emergency or consult a doctor in your state."
    />
  );
}
